import React from "react";
import Subscriber from "../../subscriber.class";
import Spec from "../specs/spec";
import Spinner from "../spinners/spinner";
import Storage from "../../services/storage.service";
import Settings from "../../services/settings.service";
import { goToStepBase } from "../../services/flow.service";
import { t } from "../../services/translation.service";
import PlanDuration from "../plan-duration/PlanDuration";
import { generalEvent } from "../../services/tracking.service";

export default class SummaryPlan extends Subscriber {
  state = {
    can_go_to_plan: true,
    isPlansPage: window.location.hash === '#/plans'
  };

  goToPlan = () => {
    Storage.clear("summary_modal");
    goToStepBase("coverage_details");
  };

  componentDidMount() {
    this.subscriptions.push(
      Storage.get_obsrv("flow_status_flags").subscribe((flow_status_flags) => {
        this.setState({
          is_plan_selected:
            flow_status_flags && flow_status_flags.is_plan_selected,
        });
      })
    );

    this.subscriptions.push(
      Storage.get_obsrv("saved_plan").subscribe((data) => {
        if (data) {
          this.setState({
            saved_plan: data,
          });
        }
      })
    );
  }

  data_plan_price = () => {
    if (Array.isArray(this.state.saved_plan.PackagePrice)){
      let plan = this.state.saved_plan.PackagePrice.find(p => p.ExtraCharges.length === 0)
      return plan.PlanNetPrice;
    }else{
     return this.state.saved_plan.PackagePrice.PlanNetPrice;
    }
  }

  render() {
    let prefix = Settings.plans_prefix;

    if (this.state.saved_plan && !this.state.isPlansPage) {
      let data_plan_id = this.state.saved_plan[prefix + "subplans_ids_by_type"][
        "DATA"
      ];
      let device_plan_id = this.state.saved_plan[
        prefix + "subplans_ids_by_type"
      ]["BroadbandDevice"];

      let data_plan = this.state.saved_plan[prefix + "subplans"][data_plan_id];
      let device_plan = this.state.saved_plan[prefix + "subplans"][
        device_plan_id
      ];

      let suffix = "Home Internet";
      // let val = null;
      // if(data_plan){
      //   val = data_plan[prefix + "ValueFormatted"]
      // }
      // if (val === Settings.unlimited_text) {
      //   if (data_plan["Name"].indexOf("Plan_5G") !== -1) {
      //     suffix = "5G";
      //   }
      //   if (data_plan["Name"].indexOf("Plan_4G") !== -1) {
      //     suffix = "4G";
      //   }
      // }
      let duration = this.state.saved_plan.product?.CommitmentDuration;
      let data_plan_price = this.data_plan_price();

      return (
        <div className="vmo-summary" 
          style={this.props?.mobileCartPopup? {height: '120%'}: {}}>
          <div className="vmo-summary-box-wrapper3">
            <div className="vmo-summary-box vmo-summary-box2">
              <div className="vmo-summary-section ">
                <div className="vmo-summary-section-header">
                  <h3>{t("PLAN_SUMMARY_BOX_TITLE")}</h3>
                  {this.state.can_go_to_plan ? (
                    <div
                      className="vmo-summary-edit"
                      onClick={() => {
                        // Events.clicks_on_summary_edit_plan("");
                        this.goToPlan();
                        let eventObj = {
                          eventCustomName : "click_cta",
                          extra_obj : {
                            cta_name: 'edit plan',
                            cta_type: 'button',
                            cta_position: 'top'
                          }
                        };
                        generalEvent(eventObj);
                        let removeEventObj = {
                          eventType : 'ecommerce_event',
                          eventCustomName : "remove_from_cart",
                        };
                        generalEvent(removeEventObj);
                      }}
                    />
                  ) : (
                    ""
                  )}
                </div>
                {data_plan &&(
                  <div className="vmo-plan-specs">
                    <Spec spec={data_plan} suffix={suffix} price={true} plan_price={data_plan_price} duration={duration} />
                  </div>
                )}
              </div>
              {device_plan && (
                <div className="vmo-summary-section ">
                  <div className="vmo-summary-section-header">
                    <h3 className="vmo-et">{t("DEVICE_SUMMARY_BOX_TITLE")}</h3>
                  </div>
                  <div className="vmo-plan-specs">
                    <Spec
                      spec={device_plan}
                      plan_price={device_plan.Price}
                      price={true}
                      override_val={"ExtraDetails"}
                      override_img={"ImageURL"}
                    />
                  </div>
                </div>
              )}
              {this.props.showPlanDuration?
                <div className="vmo-summary-section ">
                  <div className="vmo-summary-section-header">
                    <h3 className="vmo-et">{t("DURATION_SUMMARY_BOX_TITLE")}</h3>
                  </div>
                  <div className="vmo-plan-specs">
                    <PlanDuration data_plan={data_plan} duration={duration}/>
                  </div>
                </div>
              :''}
            </div>
            {this.props.showPlanDuration && duration === 12 ? 
            <div className="vmo-summary-suffix vmo-summary-unlocked summary-plan-discount-unlocked">
              <div className="vmo-summary-suffix-inner">
                <div className="vmo-summary-suffix-vertical">
                  <div className="vmo-summary-suffix-title">
                  {t("SUMMARY_UNLOCK_DISCOUNT_LABEL1")}
                  </div>
                  <div className="vmo-summary-suffix-body">
                    {t("SUMMARY_UNLOCK_DISCOUNT_LABEL2")}
                  </div>
                </div>
              </div>
            </div> : ''}

          </div>
        </div>
      );
    } else {
      if (this.state.is_plan_selected & !this.state.isPlansPage) {
        return <Spinner />;
      }
    }
    return "";
  }
}
